import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { HoldingClass } from 'types';

import NoItemsAvailable from 'modules/_shared/components/EmptyStates/NoItemsAvailable';

import { useHoldingClassListPage } from '../context/HoldingClassListPageContext';
import HoldingClassTableRow from './HoldingClassTableRow';

const HoldingClassTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useHoldingClassListPage();

  const hasData = data.holdingClasses?.length > 0;

  return (
    <>
      <tbody>
        {hasData ? (
          data.holdingClasses?.map(
            (holdingClass: HoldingClass, index: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr className="nk-tb-item" key={`holdingClass-row-${index}`}>
                <HoldingClassTableRow
                  index={index}
                  holdingClass={holdingClass}
                />
              </tr>
            )
          )
        ) : (
          <NoItemsAvailable mainMessage={t('NoHoldingClassesMessage')} />
        )}
      </tbody>
    </>
  );
};

export default HoldingClassTableBody;
